import React, { FC } from 'react'
import styled, { css } from 'styled-components'
import mq from '../../utils/mq'

import TabsContentItem from './tabs-content-item'
import { SectionTabsProps } from './section-tabs'

const StyledTabsContent = styled.div<{ theme: 'dark' | 'light' }>`
  background-color: #fff;
  padding: 60px 70px;
  ${mq.tablet(css`
    padding: 30px 30px;
  `)};

  ${({ theme }) => theme === 'dark' && css`
    background-color: transparent;
  `}
`

interface TabsContentProps extends Pick<SectionTabsProps, 'theme' | 'items' | 'dismountContent'> {
  productName?: string;
  activeIndex?: number;
  current?: unknown;
}

const TabsContent: FC<TabsContentProps> = ({
  theme,
  items,
  productName,
  activeIndex,
  current,
  dismountContent
}) => {
  return (
    <StyledTabsContent theme={theme}>
      {items.map((item, index) => {
        if (dismountContent && index !== activeIndex) return null

        return (
          <TabsContentItem
            key={index}
            productName={productName}
            active={index === activeIndex}
            current={current}
            {...item}
          />
        )
      })}
    </StyledTabsContent>
  )
}

export default TabsContent
